import styled, { css } from 'styled-components';

export const StyledButtonMedium = styled.button(
  ({
    theme,
    backgroundColor = 'oxfordBlue',
    rounded = false,
    loading = false,
  }) => css`
    display: flex;
    justify-content: ${loading ? 'center ' : 'space-between'};
    align-items: center;
    width: ${theme.width.full};
    padding: ${theme.spacing.none} ${theme.spacing.sm};
    background-color: ${theme.colors[backgroundColor]};
    border: none;
    border-radius: ${rounded ? theme.radius.l : theme.radius.s};
    height: ${theme.height.h5};
  `
);

export const StyledButtonMediumOutlined = styled.button(
  ({
    theme,
    backgroundColor = 'oxfordBlue',
    inverted,
    rounded = false,
    loading = false,
  }) => css`
    display: flex;
    justify-content: ${loading ? 'center ' : 'space-between'};
    align-items: center;
    width: ${theme.width.full};
    padding: ${theme.spacing.none} ${theme.spacing.sm};

    background-color: ${inverted
      ? theme.colors.white
      : theme.colors[backgroundColor]};
    border: 1px solid
      ${inverted ? theme.colors[backgroundColor] : theme.colors.white};
    ${rounded ? theme.radius.l : theme.radius.s};
    height: ${theme.height.h5};
    border-radius: ${rounded ? theme.radius.l : theme.radius.s};
  `
);

export const StyledButtonMediumDisabled = styled.button(
  ({ theme, rounded = false }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.spacing.none} ${theme.spacing.sm};
    background-color: ${theme.colors.dimGray};
    width: ${theme.width.full};
    border-width: 1px;
    border-radius: ${rounded ? theme.radius.l : theme.radius.s};
    height: ${theme.height.h5};
    opacity: 0.3;
  `
);
